
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es/trazabilidad-jamon",
      function () {
        return require("private-next-pages/es/trazabilidad-jamon/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es/trazabilidad-jamon"])
      });
    }
  